import { styled } from '@mui/system';

import { useI18n } from '@app-velocity/i18n';
import { Card, Page, Skeleton } from '@app-velocity/ui';

import { useUsageContext } from '../../context/useUsageContext';
import { UsageProgress } from './components/UsageProgress';
import { UsageStats } from './components/UsageStats';

const SummaryCard = styled(Card)(({ theme }) => ({
  gap: theme.spacing(4),
  display: 'flex',
  padding: theme.spacing(4),
  flexDirection: 'column',
}));

const StyledSection = styled('section')(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(3),
  flexDirection: 'column',
  width: '100%',
}));

export const Summary = () => {
  const { t } = useI18n();
  const { isLoading } = useUsageContext();

  if (isLoading) return <Skeleton borderRadius={4} height={150} />;

  return (
    <StyledSection>
      <Page.Subheader title={t('teams:usage.simulations.title')} />
      <SummaryCard>
        <Page.SectionHeader title={t('teams:usage.simulations.summary')} />
        <UsageStats />
        <UsageProgress />
      </SummaryCard>
    </StyledSection>
  );
};
